export default __webpack_public_path__ + "static/logo-c2d4acd7586c7174671cb3c5ebbe92c4.svg";